export enum RecordingStatus {
  IDLE = "IDLE",
  LOCKED = "LOCKED",
  INITIALIZING = "INITIALIZING",
  INITIALIZED = "INITIALIZED",
  RECORDING = "RECORDING",
  PAUSED = "PAUSED",
  STOPPED = "STOPPED",
  STOPPING = "STOPPING",
  UPLOADING = "UPLOADING",
  UPLOADED = "UPLOADED",
  PROCESSING = "PROCESSING",
}
